import React from 'react'
import PropTypes from 'prop-types'

import Label from '../label'
import './form-switch.styl'

let SWITCH_ID = 0;
class Switch extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            checked: props.checked
        }
        this.id = SWITCH_ID++;
    }

    handleChange(event){
        event.preventDefault();
        if(this.props.disabled) return
        this.props.onChange(this.state.checked)
        this.setState({checked: !this.state.checked});
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({checked: nextProps.checked})
    }

    render() {
        let {label, disabled, className=false, labelLeft=false, labelRight=false} = this.props;
        let {checked} = this.state

        className = 'form form-switch' + (className ? ' ' + className : '' )
        className = className + (disabled ? ' disabled' : '')
        return (<div className={className}>
            <Label>{label}</Label>

            { disabled && <div>
                <Label className='checked'>{checked ? (labelRight || 'app.on') : (labelRight|| 'app.off')}</Label>
            </div>}

            { !disabled && <div className="form-switch-button">
                <label className={!checked ? 'unchecked' : ''} htmlFor={'switch-button-' + this.id}>
                    <Label>{labelLeft || 'app.off'}</Label>
                </label>

                <input className="form-switch-button-input"
                       onChange={this.handleChange.bind(this)}
                       checked={checked}
                       id={'switch-button-' + this.id}
                       type="checkbox" />

                <div className={'form-switch-button-onOff' + (checked ? ' checked' : ' unchecked')}>
                    <div className={'form-switch-button-icon' + (checked ? ' checked' : '')} ></div>
                </div>

                <label className={checked ? 'checked' : ''} htmlFor={'switch-button-' + this.id}>
                    <Label>{labelRight || 'app.on'}</Label>
                </label>
            </div>}
        </div>);
    }
}

Switch.propTypes = {
    label: PropTypes.string,
    labelLeft: PropTypes.string,
    labelRight: PropTypes.string,
    className: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
}

Switch.defaultProps = {
    disabled: false
}

export default Switch;
